import { type ReactElement } from 'react';
import { Navigate, Outlet } from 'react-router';
import { ROUTES } from 'constants/routes';
import { getRefreshToken } from 'utils/storage';

export const PublicRoute = (): ReactElement => {
  const refreshToken = getRefreshToken();

  if (refreshToken) {
    return <Navigate to={ROUTES.HOME} />;
  }

  return <Outlet />;
};
